var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('noticeWebform',{attrs:{"organizationId":_vm.organizationId,"communicationId":_vm.communicationId,"providerCommunicationId":_vm.providerCommunicationId,"communicationType":_vm.communicationType}})
}
var staticRenderFns = []

export { render, staticRenderFns }